(() => {
  const stateSelector = '[data-cart-threshold-state]';
  const checkoutSelector = '[data-cart-threshold-checkout]';
  const acceleratedSelector = '[data-cart-threshold-accelerated]';

  const updateState = (state, suppliedCartTotal) => {
    const threshold = Number(state.dataset.threshold) || 0;
    const storedCartTotal = Number(state.dataset.cartTotal) || 0;
    const cartTotal = Number.isFinite(suppliedCartTotal) ? suppliedCartTotal : storedCartTotal;
    const belowThreshold = threshold > 0 && cartTotal < threshold;
    const container = state.closest('[data-cart-threshold-container]');

    state.dataset.cartTotal = cartTotal;
    state.dataset.belowThreshold = belowThreshold.toString();
    state.querySelectorAll('.cart-threshold-message').forEach((message) => {
      message.hidden = !belowThreshold;
    });

    if (!container) return;

    container.querySelectorAll(checkoutSelector).forEach((button) => {
      const disabled = cartTotal <= 0 || belowThreshold;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled.toString());
    });

    container.querySelectorAll(acceleratedSelector).forEach((element) => {
      element.hidden = belowThreshold;
    });
  };

  const updateAllStates = (cartTotal) => {
    document.querySelectorAll(stateSelector).forEach((state) => updateState(state, cartTotal));
  };

  const refreshFromCart = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) return;
      const cart = await response.json();
      updateAllStates(Number(cart.total_price));
    } catch (error) {
      console.error('Unable to refresh the cart threshold state.', error);
    }
  };

  const handleCartUpdate = (event) => {
    window.setTimeout(() => {
      const cartTotal = Number(event?.cartData?.total_price);
      if (Number.isFinite(cartTotal)) {
        updateAllStates(cartTotal);
      } else {
        refreshFromCart();
      }
    }, 0);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const checkoutButton = event.submitter?.matches(checkoutSelector) ? event.submitter : null;
      if (!checkoutButton) return;

      const container = checkoutButton.closest('[data-cart-threshold-container]');
      const state = container?.querySelector(stateSelector);
      if (state?.dataset.belowThreshold === 'true') {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => updateAllStates());

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }
})();
